import { render, staticRenderFns } from "./eventDetail.vue?vue&type=template&id=5603b2df&scoped=true"
import script from "./eventDetail.vue?vue&type=script&lang=ts"
export * from "./eventDetail.vue?vue&type=script&lang=ts"
import style0 from "./eventDetail.vue?vue&type=style&index=0&id=5603b2df&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5603b2df",
  null
  
)

export default component.exports